import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CheckoutButton } from '../CheckoutButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const perks = ['One-time payment', 'Lifetime access', 'No monthly subscription', 'Instant digital access'];
export function OfferSection() {
  return <section id="offer" className="bg-sand-50 px-4 py-14 sm:py-20" data-id="element-246" data-mp="aijse7cm3y4x">
      <div className="mx-auto w-full max-w-2xl" data-id="element-247" data-mp="6i9m0tkwr5pj">
        <div className="text-center" data-id="element-248" data-mp="6j189dsm7r35">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-aqua-500" data-id="element-249" data-mp="1q816j9oc6nw">
            🏆 Special launch offer
          </p>
          <h2 className="mt-3 font-display text-[27px] font-bold leading-[1.14] tracking-tight text-navy-900 sm:text-4xl" data-id="element-250" data-mp="3sx2jdtwifrs7">
            Here's everything you get today
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-card ring-1 ring-navy-800/10" data-id="element-251" data-mp="3ixtn2ue6a12o">
          <ul className="divide-y divide-navy-800/8" data-id="element-252" data-mp="3ez4erg7zr9pw">
            <li className="flex items-start justify-between gap-4 p-5" data-id="element-253" data-mp="1arqykjn8vjwd">
              <div className="min-w-0" data-id="element-254" data-mp="1fih0to0dj6mu">
                <p className="text-[15px] font-extrabold text-navy-900" data-id="element-255" data-mp="1fjimsnixhdjc">📘 PROSTHO 360™</p>
                <p className="mt-0.5 text-[13.5px] text-navy-800/60" data-id="element-256" data-mp="10uvxbszl75ee">
                  The complete Prosthodontics study system
                </p>
              </div>
              <p className="shrink-0 text-[14px] font-bold text-navy-800/45 line-through" data-id="element-257" data-mp="1tirt8vhc0ta4">$97</p>
            </li>
            <li className="flex items-start justify-between gap-4 p-5" data-id="element-258" data-mp="1yi4mpz2pkylo">
              <div className="min-w-0" data-id="element-259" data-mp="1khtzd60ly259">
                <p className="text-[15px] font-extrabold text-navy-900" data-id="element-260" data-mp="1kgsbu22enn6n">🎁 5 exclusive bonuses</p>
                <p className="mt-0.5 text-[13.5px] text-navy-800/60" data-id="element-261" data-mp="1oidw48h9r3qv">
                  Flashcards, 7-day sprint, comparisons, exam check, cheat sheets
                </p>
              </div>
              <p className="shrink-0 text-[14px] font-bold text-navy-800/45 line-through" data-id="element-262" data-mp="d4idgpr5ocuw">$133</p>
            </li>
            <li className="flex items-center justify-between gap-4 bg-sand-100 p-5" data-id="element-263" data-mp="2fpm46e72ej4z">
              <p className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-navy-800/60" data-id="element-264" data-mp="2arkom38ul1y9">
                Total value
              </p>
              <p className="text-[19px] font-extrabold text-navy-800/50 line-through" data-id="element-265" data-mp="25z174v71hmo6">$230</p>
            </li>
          </ul>

          <div className="bg-navy-900 p-6 text-center text-white sm:p-8" data-id="element-266" data-mp="1x0639prgwoo1">
            <p className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-aqua-200" data-id="element-267" data-mp="1wycw89cy02fi">
              Today, you can get everything for just
            </p>
            <p className="mt-2 font-display text-[64px] font-bold leading-none tracking-tight sm:text-7xl" data-id="element-268" data-mp="1n31dzh2bsd30">
              $27
            </p>

            <ul className="mx-auto mt-5 grid max-w-sm grid-cols-2 gap-2" data-id="element-269" data-mp="3hgaqlhq64eph">
              {perks.map(perk => <li key={perk} className="flex items-center gap-1.5 rounded-lg bg-white/8 px-2.5 py-2 text-left text-[12px] font-semibold leading-tight" data-id="element-270" data-mp="3chfytqa83ft8">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-aqua-400" aria-hidden="true" data-id="element-271" data-mp="3oza79fm8vs55" />
                  {perk}
                </li>)}
            </ul>

            <p className="mt-5 text-[14px] leading-relaxed text-white/70" data-id="element-272" data-mp="2k7o73wmrl2l">
              For less than the cost of a typical study resource, you get a complete visual system you can
              return to every time you need to review Prosthodontics.
            </p>

            <div className="mt-6" data-id="element-273" data-mp="3617q1mzxuzhw">
              <CheckoutButton label="Get Prostho 360™" sub="One-time payment of $27 · Instant access · 7-Day Guarantee" variant="light" data-id="element-274" data-mp="3b00tsnpfbc4v" />
            </div>

            <div className="mt-6" data-id="element-275" data-mp="qabfqcwjnud8">
              <Countdown tone="dark" data-id="element-276" data-mp="q9a2q2vywxsv" />
            </div>

            <p className="mx-auto mt-5 flex max-w-sm items-center justify-center gap-2 rounded-xl bg-white/8 px-3 py-2.5 text-[12px] leading-snug text-white/75" data-id="element-277" data-mp="v8d9brrljc2y">
              <GlobeIcon className="h-4 w-4 shrink-0 text-aqua-400" aria-hidden="true" data-id="element-278" data-mp="247xmybxn34v0" />
              Currency conversion is adjusted automatically based on your country.
            </p>
          </div>
        </div>

        <div className="mt-6" data-id="element-279" data-mp="287ern358rxz4">
          <ScarcityBar data-id="element-280" data-mp="2875be7a0156m" />
        </div>
      </div>
    </section>;
}